export default [
  {
    filing_status: 'submitted',
    review_status: 'approved',
    voting_active: false,
    is_voted: false,
    buttons: ['print', 'downloadCertificate', 'downloadPDF'],
    comments_visible: true,
    can_comment: false,
    edit: 'not_allowed',
    schedule: 'none',
  },
  {
    filing_status: 'submitted',
    review_status: 'declined',
    voting_active: false,
    is_voted: false,
    buttons: ['print'],
    comments_visible: false,
    can_comment: false,
    edit: 'not_allowed',
    schedule: 'none',
  },
  {
    filing_status: 'submitted',
    review_status: 'waiting_for_voting',
    buttons: {
      buttonsBeforeVoting: ['vote', 'print'],
      buttonsDuringVoting: ['preliminaryResults', 'print'],
    },
    comments_visible: true,
    can_comment: true,
    edit: 'not_allowed',
    schedule: 'view',
  },
  // {
  //   filing_status: 'submitted',
  //   review_status: 'waiting_for_voting',
  //   is_voted: false,
  //   voting_active: true,
  //   buttons: ['vote', 'print'],
  //   comments_visible: true,
  //   can_comment: false,
  //   edit: 'not_allowed',
  //   schedule: 'view',
  // },
  // {
  //   filing_status: 'submitted',
  //   review_status: 'waiting_for_voting',
  //   is_voted: true,
  //   voting_active: true,
  //   buttons: ['preliminaryResults', 'voteDisabled', 'print'],
  //   comments_visible: true,
  //   can_comment: false,
  //   edit: 'not_allowed',
  //   schedule: 'view',
  // },
];
